import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import './style.scss';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'COURIER_USER_ALL',
        delete: 'COURIER_USER_DELETE',
        black: 'COURIER_USER_BLACK'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        width: '160px'
      }, // { prop: 'user_uid', label: 'user_uid', width: '160px' },
      {
        prop: 'market_id',
        label: this.$t('market_mobile'),
        minWidth: '120px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "table_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'company_name',
        label: this.$t('company_name'),
        width: '160px'
      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        width: '160px'
      }, {
        prop: 'nick_name',
        label: this.$t('nick_name'),
        width: '160px'
      }, {
        prop: 'user_status',
        label: this.$t('user_status'),
        width: '160px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "user_status",
              "value": row.user_status
            }
          });
        }
      }, {
        prop: 'user_pwd',
        label: this.$t('user_pwd'),
        width: '160px'
      }, {
        prop: 'qr_code',
        label: this.$t('qr_code'),
        minWidth: '120px',
        render: function render(_ref3) {
          var row = _ref3.row;
          return h("el-image", {
            "attrs": {
              "src": _this2.$env.VUE_APP_QRCODE + row.user_mobile.substring(row.user_mobile.length - 11) + '@' + encodeURIComponent(row.user_pwd),
              "fit": "cover",
              "preview-src-list": [_this2.$env.VUE_APP_QRCODE + row.user_mobile.substring(row.user_mobile.length - 11) + '@' + encodeURIComponent(row.user_pwd)],
              "lazy": true
            },
            "style": "height: 28px; width: 28px; border-radius: 2px;"
          }, [h("div", {
            "slot": "error",
            "style": "height: 100%; width: 100%;",
            "attrs": {
              "flex": "main:center cross:center"
            }
          }, [h("i", {
            "class": "el-icon-picture-outline"
          })])]);
        }
      }, {
        prop: 'balance',
        label: this.$t('balance'),
        width: '160px',
        formatter: function formatter(row) {
          return row.balance ? row.balance / 100 : '0';
        }
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'black_list',
        label: this.$t('black_list'),
        width: '160px',
        formatter: function formatter(row) {
          return row.black_list == 1 ? 'black courier' : '';
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this3 = this;

      return function (_ref4) {
        var row = _ref4.row;
        return [].concat(_toConsumableArray(_this3.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this3.edit(row.id);
          }
        }], [])), _toConsumableArray(_this3.p('detail', [{
          icon: 'el-icon-collection',
          label: _this3.$t('device-count'),
          action: function action() {
            return _this3.goAdminDeviceData(row.user_mobile);
          }
        }], [])), _toConsumableArray(row.black_list == 0 ? _this3.p('detail', [{
          icon: 'el-icon-s-check',
          label: _this3.$t('add black'),
          confirm: _this3.$t('confirm_add_black'),
          action: function action() {
            return _this3.black(row.user_mobile, 1);
          }
        }], []) : _this3.p('detail', [{
          icon: 'el-icon-s-check',
          label: 'delete black',
          confirm: _this3.$t('confirm_delete_black'),
          action: function action() {
            return _this3.black(row.user_mobile, 0);
          }
        }], [])), _toConsumableArray(_this3.p('download', [{
          icon: 'el-icon-download',
          type: '',
          confirm: _this3.$t('confirm_download_info'),
          action: function action() {
            return _this3.download(row);
          }
        }], [])), _toConsumableArray(_this3.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this3.$t('confirm_delete_info'),
          action: function action() {
            return _this3.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this4 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this4.search.form.model.market_id,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: this.market_mobile ? this.market_mobile : utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this4.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "market_mobile", $$v);
              }
            }
          });
        },
        show: !!utils.cookies.get('phone') // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:100px;" custom clearable/>

      }, {
        prop: 'user_mobile',
        label: this.$t('user_mobile'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this4.search.form.model.user_mobile,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "user_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.start_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this4.search.form.model.end_time,
              callback: function callback($$v) {
                _this4.$set(_this4.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_id: function market_id() {
      return this.$route.query.market_id;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    /**
           * @description 加载需要的字典数据
           */
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'market_id,market_name',
        path: 'list',
        label: 'market_name',
        value: 'market_id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      }); // 分类

      this.loadDictOne({
        name: 'market_id',
        method: this.$api.MARKET_ALL,
        fields: 'market_id,market_name',
        path: 'list',
        label: 'market_name',
        value: 'market_id'
      });
    },
    goAdminDeviceData: function goAdminDeviceData(user_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-courier-device-count';
      });
      this.$router.push({
        name: 'management-courier-device-count',
        query: {
          user_mobile: user_mobile
        }
      });
    },
    goAdminRecordData: function goAdminRecordData(admin_user_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-admin-record';
      });
      this.$router.push({
        name: 'management-wash-admin-record',
        query: {
          admin_user_id: admin_user_id
        }
      });
    },
    black: function black(user_mobile, _black) {
      var _this5 = this;

      var blackFunction = this.$api[this.api.black];

      if (!this._.isFunction(blackFunction)) {
        this.$message.error('not find API');
        return;
      }

      blackFunction(user_mobile, _black).then(function () {
        _this5.$message.success('operating success');

        _this5.research();
      }).catch(function () {});
    },
    tableRowClassName: function tableRowClassName(_ref5) {
      var row = _ref5.row,
          rowIndex = _ref5.rowIndex;

      if (row.black_list == 1) {
        return 'warning-row';
      }

      return 'courier-user';
    }
  })
};